import React, {useState} from 'react';

function Upload(props) {
    const [selectedFile, setSelectedFile] = useState();
    const [isSelected, setIsSelected] = useState(false);
    const [isAllowed, setIsAllowed] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);
    const [fileUrl, setFileUrl] = useState();
    const [input] = useState(React.createRef());

    const changeHandler = (event) => {
        if (event.target) {
            let file = event.target.files[0];
            if (file) {
	        setSelectedFile(file);
	        setIsSelected(true);
                setIsUploaded(false);
                setIsAllowed(false);
                setFileUrl(null);
                if (file.size < 16000000) {
                    setIsAllowed(true);
                }
            }
        }
    };

    const deleteSubmission = (e) => {
        setSelectedFile(null);
        setIsSelected(false);
        setIsAllowed(false);
        setIsUploaded(false);
        setFileUrl(null);
        input.current.value = null;
    };

    const handleSubmission = () => {
        if (isAllowed) {
	    const formData = new FormData();
	    formData.append('file', selectedFile);
	    formData.append('access', 1);

	    fetch(
	        '/files',
	        {
		    method: 'POST',
		    body: formData,
	        }
	    )
	        .then((response) => response.json())
	        .then((result) => {
                    if (result.url) {
                        console.log('Success:', result);
                        setIsUploaded(true);

                        //TODO: change for alterozoom if needed
                        const prefix = "https://ecoimpact-ple.com";
                        const parts = result.url.split("/");
                        const encoded_url = parts.slice(0,-1).join("/") + "/" + encodeURIComponent(parts[parts.length-1]);
                        setFileUrl(prefix + encoded_url);
                    }
	        })
	        .catch((error) => {
		    console.error('Error:', error);
                    alert('Upload error: '+JSON.stringify(error));
	        });

        }
    };

    const copyFileLink = () => {
        var copyText = document.querySelector("#fileLink");
        copyText.select();
        document.execCommand("copy");

    };


    return(
        <div style={{margin:5}}>
	    <input ref={input} type="file" name="file" onChange={changeHandler} />&nbsp;&nbsp;
	    {isSelected ? (
	        <span></span>
	    ) : (<span>Max file size: 15Mb</span>
	        )}
	    <span>
	        {isSelected && isAllowed && !isUploaded && <button onClick={handleSubmission}>Upload</button>}
                {isUploaded && fileUrl && <input style={{maxWidth: "300px"}} id="fileLink" type="text" value={fileUrl}/>}
	        {isSelected && isAllowed && isUploaded && <button onClick={copyFileLink}>Copy file link</button>}
	        {isSelected && !isAllowed && <span>Your file is larger than 15Mb</span>}
	        {isSelected && <button onClick={deleteSubmission}>Delete</button>}
	    </span>
        </div>
    )
};


export default Upload;
